export default "__VITE_ASSET__CJXP$_i1__"